import config from '../../config';

export default {
  url: `${config.api.baseURL}/discharge-intro`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/dischargeContent/list.js